import { ToastWidget } from '@tableau/widgets';
import React from 'react';

import { InformationBox } from '../header/InformationBox';
import { InformationObject } from '../state/InlineBannerInfoState';
import { InlineToasterStyle, PopupToasterStyle } from './ToasterStyles';

export interface InformationProps {
  info: InformationObject;
}

const style: React.CSSProperties = {
  margin: '0 auto',
};

export function PageBanner(props: {info: InformationObject}): JSX.Element {

  React.useEffect(() => {
    ToastWidget.updateToasterStyle(InlineToasterStyle);

    return () => {
      ToastWidget.updateToasterStyle(PopupToasterStyle);
    };
  }, []);

  return <div style={style}>
        <InformationBox
          display={props.info.display}
          action={props.info.action}
          message={props.info.message}
          actionMessage={props.info.actionMessage}
        />
      </div>;
}

export function PageHeaderInformation(props: InformationProps): JSX.Element {
  const info: InformationObject = props.info;

  if (info && info.display) {
    return <PageBanner info={info}/>;
  }
}
